<template>
  <div>
    <div class="whitePanel marginBottom">
      <div class="grid">
        <div class="col-12 md:col-3">
          <p class="blueText marginB5Px">
            {{ $t("expedientes.label.nReferenciaExp") }}
          </p>
          <InputText
            v-model="filters['token']"
            class="input"
            id="idBorrador"
            type="text"
            :placeholder="$t('expedientes.placeholders.nReferencia')"
          />
        </div>
        <div class="col-12 md:col-3">
          <p class="blueText marginB5Px">
            {{ $t("expedientes.label.referenciaCliente") }}
          </p>
          <InputText
            v-model="filters['referenciaCliente']"
            class="input"
            id="idBorrador"
            type="text"
            :placeholder="$t('expedientes.placeholders.nReferencia')"
          />
        </div>
        <div class="col-12 md:col-3">
          <p class="blueText marginB5Px">
            {{ $t("expedientes.label.nombreReclamado") }}
          </p>
          <InputText
            v-model="filters['deudor.nombre']"
            class="input"
            id="nombre"
            type="text"
            :placeholder="$t('expedientes.placeholders.nombreReclamado')"
          />
        </div>
        <div class="col-12 md:col-3">
          <p class="blueText marginB5Px">
            {{ $t("expedientes.label.nifReclamado") }}
          </p>
          <InputText
            v-model="filters['deudor.idLegal']"
            class="input"
            id="dni"
            type="text"
            :placeholder="$t('expedientes.placeholders.nifReclamado')"
          />
        </div>
        <div class="col-12 md:col-3">
          <p class="blueText marginB5Px">
            {{ $t("expedientes.label.nombreAcreedor") }}
          </p>
          <InputText
            v-model="filters['acreedor.nombre']"
            class="input"
            id="nombre"
            type="text"
            :placeholder="$t('expedientes.placeholders.nombreAcreedor')"
          />
        </div>
        <div class="col-12 md:col-3">
          <p class="blueText marginB5Px">
            {{ $t("expedientes.label.nifAcreedor") }}
          </p>
          <InputText
            v-model="filters['acreedor.idLegal']"
            class="input"
            id="dni"
            type="text"
            :placeholder="$t('expedientes.placeholders.nifAcreedor')"
          />
        </div>
        <div class="col-12">
          <div class="flex justify-content-end">
            <Button
              @click="clearFields()"
              :label="$t('expedientes.label.limpiar')"
              class="buttonStyle rightAlign lightBlueBG"
            />
          </div>
        </div>
      </div>
    </div>
    <DataTable
      :value="operations.items"
      :loading="loading"
      :lazy="true"
      :paginator="true"
      :rows="tamPagina"
      :totalRecords="operations.totalElements"
      :filters.sync="filters"
      :expandedRows.sync="expandedRows"
      class="p-datatable-responsive expendientesDataTable"
      :autoLayout="true"
      dataKey="token"
      @sort="customSort($event)"
      @page="onPage($event)"
      @row-click="clicked"
    >
      <template #empty>
        {{ $t("expedientes.datatable.noExpedientes") }}
      </template>

      <template #footer>
        <div class="grid">
          <div class="col-4 col-offset-8" style="text-align: right">
            <Button
              @click="exportarExcelOperacionByFilters(backendFilters, sort)"
              :icon="
                !exportandoDatos
                  ? 'pi pi-external-link'
                  : 'pi pi-spin pi-spinner'
              "
              :label="$t('common.buttons.export')"
              class="p-button-text p-button-outlined"
              :disabled="
                exportandoDatos || !operations || operations.totalElements == 0
              "
            />
          </div>
        </div>
      </template>

      <Column :expander="true" headerStyle="width: 3em">
        <template #header>
          <button
            class="p-row-toggler p-link center"
            @click="expandOrCollapse()"
          >
            <span :class="expandClass"></span>
          </button>
        </template>
      </Column>

      <Column
        field="token"
        :header="$t('expedientes.header.nReferenciaLargeExp')"
        :sortable="false"
        headerStyle="width: 11em"
      >
        <template #body="slotProps">
          <span class="column-title">{{
            $t("expedientes.label.nReferenciaExp")
          }}</span>
          {{ slotProps.data.token }}
        </template>
      </Column>
      <Column
        field="referenciaCliente"
        :header="$t('expedientes.header.referenciaCliente')"
        :sortable="false"
        headerStyle="width: 11em"
      >
        <template #body="slotProps">
          <span class="column-title">{{
            $t("expedientes.label.referenciaCliente")
          }}</span>
          {{ slotProps.data.referenciaCliente }}
        </template>
      </Column>
      <Column
        field="fechaAlta"
        :header="$t('expedientes.header.fecha')"
        :sortable="true"
        headerStyle="width: 7em"
      >
        <template #body="slotProps">
          <span class="column-title">{{
            $t("expedientes.label.fecha")
          }}</span>
          {{ getFormattedDateShort(slotProps.data.fechaAlta) }}
        </template>
      </Column>
      <Column
        field="reclamado"
        :header="$t('expedientes.header.reclamado')"
        :sortable="false"
        :headerStyle="headerStyle"
      >
        <template #body="slotProps">
          <span class="column-title">{{
            $t("expedientes.label.reclamado")
          }}</span>
          {{
            getFullName(
              slotProps.data.deudorNombre,
              slotProps.data.deudorApellidos,
              slotProps.data.deudorRazonSocial
            )
          }}
        </template>
      </Column>
      <Column
        field="acreedor"
        :header="$t('expedientes.header.acreedor')"
        :sortable="false"
        :headerStyle="headerStyle"
      >
        <template #body="slotProps">
          <span class="column-title">{{
            $t("expedientes.label.acreedor")
          }}</span>
          {{
            getFullName(
              slotProps.data.acreedorNombre,
              slotProps.data.acreedorApellidos,
              slotProps.data.acreedorRazonSocial
            )
          }}
        </template>
      </Column>
      <template #expansion="slotProps">
        <div>
          <DataTable
            :value="slotProps.data.listaReclamaciones.results"
            :header="$t('expedientes.header.reclamacion')"
            class="p-datatable-responsive tableExpansion expedientesDatatable"
          >
            <Column
              field="token"
              :header="$t('expedientes.header.nReferenciaLarge')"
              :sortable="false"
              :headerStyle="headerStyle"
            >
              <template #header>
                {{ $t("expedientes.label.nReferencia") }}
              </template>
              <template #body="slotProps">
                <span class="column-title">{{
                  $t("expedientes.label.nReferencia")
                }}</span>
                <template v-if="slotProps.data.referenciaCliente">
                  {{ slotProps.data.referenciaCliente }}
                </template>
                <template v-else>
                  {{ slotProps.data.token }}
                </template>
              </template>
            </Column>
            <Column
              field="fechaAlta"
              :header="$t('expedientes.header.fecha')"
              :sortable="true"
              :headerStyle="headerStyle"
            >
              <template #header>
                {{ $t("expedientes.label.fecha") }}
              </template>
              <template #body="slotProps">
                <span class="column-title">{{
                  $t("expedientes.label.fecha")
                }}</span>
                {{ getFormattedDateShort(slotProps.data.fechaAlta) }}
              </template>
            </Column>
            <Column
              field="totalPendiente"
              :header="$t('expedientes.header.pendiente')"
              :sortable="false"
              :headerStyle="headerStyle"
            >
              <template #header>
                {{ $t("expedientes.label.pendiente") }}
              </template>
              <template #body="slotProps">
                <span class="column-title">{{
                  $t("expedientes.label.pendiente")
                }}</span>
                {{
                  slotProps.data.totalPendiente
                    | toCurrency("es-ES", slotProps.data.divisa)
                }}
              </template>
            </Column>
            <Column
              field="estado"
              :header="$t('expedientes.header.estado')"
              :sortable="false"
              :headerStyle="headerStyle"
            >
              <template #header>
                {{ $t("expedientes.label.estado") }}
              </template>
              <template #body="slotProps">
                <span class="column-title">{{
                  $t("expedientes.label.estado")
                }}</span>
                {{ slotProps.data.literalEstado.valor }}
              </template>
            </Column>
            <Column
              field="ficha"
              :header="$t('expedientes.header.ficha')"
              :sortable="false"
              :headerStyle="headerStyle"
              bodyStyle="text-align:center"
            >
              <template #header>
                {{ $t("expedientes.label.ficha") }}
              </template>
              <template #body="slotProps">
                <Button
                  class="ficha centerButton"
                  :label="$t('common.buttons.ver')"
                  icon="pi pi-chevron-right"
                  iconPos="right"
                  @click="onSeeClaimClick(slotProps.data.token)"
                />
              </template>
            </Column>
          </DataTable>
        </div>
      </template>
    </DataTable>
  </div>
</template>

<script>
import { QUERY_GET_OPERATIONS } from "@/graphQLQueries/OperacionQueries";
import DatesMixin from "@/utils/dates";
import StringsMixin from "@/utils/strings";
import CurrencyMixin from "@/utils/currency";
import RoutesMixin from "@/utils/routes";
import ExportExcelMixin from "@/utils/exportExcel";

export default {
  name: "Expedientes",
  mixins: [
    DatesMixin,
    StringsMixin,
    CurrencyMixin,
    RoutesMixin,
    ExportExcelMixin,
  ],
  data() {
    return {
      sort: ["-fechaAlta"],
      numPagina: 0,
      tamPagina: 10,
      loading: true,
      expandedRows: [],
      detallesReclamacion: {},
      filters: {},
      drafts: [],
      operations: { items: [], totalElements: 0 },
      headerStyle: "text-align: center",
      expandClass:
        "column-title p-row-toggler-icon pi pi-fw p-clickable pi-chevron-right",
    };
  },
  apollo: {
    operations: {
      query: QUERY_GET_OPERATIONS,
      variables() {
        return {
          criteria: {
            filter: this.backendFilters,
            page: this.numPagina,
            size: this.tamPagina,
            sort: this.sort,
          },
          idioma: this.$i18n.locale,
        };
      },
      fetchPolicy: "no-cache",
      update(data) {
        const operations = data.listaOperaciones;
        this.loading = false;
        return {
          items: operations.results,
          totalElements: operations.totalElements,
        };
      },
      skip() {
        if (
          this.$store.state.clienteUuid != null &&
          this.$store.state.clienteUuid != undefined
        ) {
          return false;
        } else {
          this.loading = false;
          return true;
        }
      },
    },
  },
  computed: {
    backendFilters() {
      let filters2 = [
        `usuario.cliente.uuid~uuid=${this.$store.state.clienteUuid}`,
      ];
      for (let [key, value] of Object.entries(this.filters)) {
        if (value != null && value != undefined && `${value}`) {
          filters2.push(`${key}~ilike=${value}`);
        }
      }
      return filters2;
    },
  },
  methods: {
    clearFields() {
      this.filters = {};
    },
    search() {
      this.loading = true;

      this.$apollo.queries.operations.refetch();
    },
    onPage(event) {
      this.numPagina = event.page;
    },
    customSort(event) {
      var sortField = event.sortField;
      var sortOrder = event.sortOrder == -1 ? "-" : "";
      var sortToApply = sortOrder + sortField;
      var sorts = [sortToApply];
      this.sort = sorts;
      this.search();
    },
    expandOrCollapse() {
      this.expandClass.includes("pi-chevron-right") == true
        ? this.expandAll()
        : this.collapseAll();
    },
    expandAll() {
      this.expandClass =
        "column-title p-row-toggler-icon pi pi-fw p-clickable pi-chevron-down";
      this.expandedRows = this.operations.items.filter((o) => o.token);
    },
    collapseAll() {
      this.expandClass =
        "column-title p-row-toggler-icon pi pi-fw p-clickable pi-chevron-right";
      this.expandedRows = [];
    },
    onSeeClaimClick(token) {
      this.goToClaimView(token);
    },
    clicked(value) {
      if (this.expandedRows.includes(value.data)) {
        this.expandClass =
          "column-title p-row-toggler-icon pi pi-fw p-clickable pi-chevron-right";
        const index = this.expandedRows.indexOf(value.data);
        if (index > -1) {
          this.expandedRows.splice(index, 1);
        }
      } else {
        this.expandClass =
          "column-title p-row-toggler-icon pi pi-fw p-clickable pi-chevron-down";
        this.expandedRows.push(value.data);
      }
    },
  },
};
</script>

<style lang="scss">
</style>


<style lang="scss" scoped>
.padding {
  padding: 2%;
}

.botonFiltrar {
  margin-right: 5px;
}

.column-title {
  color: white;
}

// RESPONSIVE
.p-datatable-responsive .p-datatable-tbody > tr > td .column-title {
  display: none;
}

@media screen and (max-width: 640px) {
  .column-title {
    color: black;
  }
}

@media screen and (max-width: 960px) {
  .centerButton {
    width: 100% !important;
  }
}
</style>
